import { useEffect, useState } from "react";
import { api, copy, type Token } from "./api";

const when = (iso: string | null) => (iso ? new Date(iso).toLocaleString() : "never");

export function Tokens() {
  const [list, setList] = useState<Token[] | null>(null);
  const [name, setName] = useState("");
  const [fresh, setFresh] = useState<Token | null>(null);
  const [error, setError] = useState("");

  const load = () => api<Token[]>("/api/tokens").then(setList).catch((e) => setError(e.message));
  useEffect(() => { load(); }, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    try {
      const t = await api<Token>("/api/tokens", { method: "POST", body: JSON.stringify({ name }) });
      setFresh(t); setName(""); load();
    } catch (err) { setError((err as Error).message); }
  }

  async function revoke(t: Token) {
    if (!confirm(`Revoke the API key "${t.name}"? Installers and scripts using it stop working.`)) return;
    await api(`/api/tokens/${t.id}`, { method: "DELETE" });
    load();
  }

  return (
    <>
      <p className="muted">An API key lets an installer or a script on your machines use this account: fetch your saved keys, read and write machine profiles. Treat it like a password; revoke one you no longer need.</p>
      <form className="panel card row" onSubmit={create}>
        <input type="text" placeholder="What is it for, e.g. new machines" value={name} onChange={(e) => setName(e.target.value)} style={{ flex: 1, minWidth: 180 }} />
        <button className="btn primary">Create API key</button>
      </form>
      {error && <div className="notice error" style={{ marginBottom: 16 }}>{error}</div>}
      {fresh && (
        <div className="notice ok" style={{ marginBottom: 16 }}>
          <strong>Copy the API key now.</strong> It is shown only once; the site keeps only a hash of it.
          <div className="row" style={{ flexWrap: "nowrap" }}>
            <div className="tokenbox grow">{fresh.token}</div>
            <button type="button" className="btn small" onClick={() => copy(fresh.token!)}>Copy</button>
          </div>
          <span className="muted small">Paste it when <code>curl -fsSL {location.origin}/install/claude | sh</code> asks.</span>
        </div>
      )}
      {list === null ? <div className="empty">Loading…</div> : list.length === 0 ? (
        <div className="empty">No API keys yet.</div>
      ) : (
        <div className="list">
          {list.map((t) => (
            <div className="panel" key={t.id}>
              <div className="grow">
                <div className="name">{t.name} <span className="mono muted" style={{ fontWeight: 400 }}>{t.prefix}…</span></div>
                <div className="meta">created {when(t.created_at)} · last used {when(t.last_used_at)}</div>
              </div>
              <button className="btn small danger" onClick={() => revoke(t)}>Revoke</button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
